import { Create } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";
import { useLocation } from "react-router-dom";
const CreateCampaigns = () => {
  const location = useLocation();
  const isClone = location?.state?.isClone;
  return (
    <Create
      title={isClone ? "Клониране на предварителна кампания" : "Създаване на предварителна кампания"}
      actions={<BackButtonToolbar />}
    >
      <SaveForm isClone={isClone} />
    </Create>
  );
};
export default CreateCampaigns;
